import { defineAction } from '~/prix'
import synchronizeOlapAction from './synchronizeOlap.action.json' with { type: 'json' }
import { z } from 'zod'

const synchronizeOlapDefinition = defineAction({
  ...synchronizeOlapAction,

  input: z.object({
    tables: z.string().optional(),
    exceptions: z.string().optional(),
    health: z.boolean().optional(),
    geo: z.boolean().optional(),
    education: z.boolean().optional(),
    economy: z.boolean().optional(),
  }),
  output: z.object({}),
})

export default synchronizeOlapDefinition
